// import paths from './paths';

export default [
  {
    path: '/',
    redirect: '/dashboard',
    component: () => import('@/views/Main.vue'),
    meta: {
      requiresAuth: true
    }
    // children: paths.map(path => route(path.path, path.view, path.name))
    // children: paths.map(path => route(path.path, path.component, path.name))
  },
  {
    path: '/login',
    component: () => import('@/views/login/Login.vue')
  },
  {
    // Always leave this as last one
    path: '*',
    component: () => import('@/views/404.vue')
  }
]
